import { DataElementIdAttribute } from './dataelementidattribute.model';

export class ConditionType {
  dataElementId: string;
  comparisonValue: any;  
}
